import type { Subject } from '../../content/api.js';

/**
 * La marca de una asignatura: color **más** inicial.
 *
 * El cuadrado de color a secas incumplía el principio de que nada se comunica solo por color, en
 * un producto que lo tiene como principio fundacional. La inicial cuesta nada y resuelve tanto el
 * daltonismo como la escala de grises.
 */
export function MarcaAsignatura({
  subject,
  size = 44,
}: {
  subject: Subject;
  size?: number;
}): React.JSX.Element {
  return (
    <span
      aria-hidden="true"
      style={{ backgroundColor: subject.color, width: size, height: size }}
      className="rounded-chip border-edge font-display flex shrink-0 items-center justify-center border-2 font-bold text-white"
    >
      {subject.name.trim().charAt(0).toUpperCase()}
    </span>
  );
}
